import { WindowsOutlined } from '@ant-design/icons';
import { Badge, Button, Tooltip } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import CustomContext from '../../context/CustomContext';
import notificationService from '../../services/NotificationService';
import sharePointService from '../../services/SharePointService';
import styles from './SharePointComponent.module.scss';

/**
 * Returns the header component.
 * @returns the header component.
 */
const SharePointComponent = (): React.ReactElement => {
    /*** HOOKS ***/

    const intl = useIntl();
    const context = useContext(CustomContext);
    const { providerAuths } = context;
    const [active, setActive] = useState<boolean>();
    const [sharepointAllowed, setSharepointAllowed] = useState<boolean>();

    /*** EFFECTS ***/

    useEffect(() => {
        const initialize = async () => {
            try {
                const sharepointAllowed = !!sharePointService.azureEntraIdClient;
                setSharepointAllowed(sharepointAllowed);
                if (sharepointAllowed && providerAuths.includes('SHAREPOINT')) {
                    setActive(true);
                } else {
                    setActive(false);
                }
            } catch (error) {
                notificationService.displayError(error, intl);
            }
        };
        initialize();
    }, [intl, providerAuths]);

    /*** METHODS ***/

    const connect = async () => {
        try {
            await sharePointService.signIn();
            const accessToken = await sharePointService.getAccessTokenFromCache();
            setActive(!!accessToken);
        } catch (error) {
            notificationService.displayError(error, intl);
        }
    };

    /*** COMPONENTS ***/

    if (sharepointAllowed && active) {
        return (
            <Tooltip
                title={<FormattedMessage id="header.settings.sharepoint.active.tooltip" />}
                className={styles.icon}
            >
                <Badge dot offset={[-3, 5]} color="green">
                    <Button type="link" icon={<WindowsOutlined />} />
                </Badge>
            </Tooltip>
        );
    } else if (sharepointAllowed && active === false) {
        return (
            <Tooltip
                title={<FormattedMessage id="header.settings.sharepoint.inactive.tooltip" />}
                className={styles.icon}
            >
                <Badge dot offset={[-3, 5]}>
                    <Button type="link" icon={<WindowsOutlined />} onClick={connect} />
                </Badge>
            </Tooltip>
        );
    } else if (sharepointAllowed) {
        return (
            <Tooltip
                title={<FormattedMessage id="header.settings.sharepoint.connecting.tooltip" />}
                className={styles.icon}
            >
                <Button type="link" icon={<WindowsOutlined />} />
            </Tooltip>
        );
    } else {
        return <></>;
    }
};
export default SharePointComponent;
